var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"listItem"},[_c('a',{staticStyle:{"font-weight":"bold","font-size":"14px","text-decoration":"none"},attrs:{"href":_vm.url,"target":"_blank"},domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }